export const KPItableheading = [
    "",
    "Sr.#",
    "Indicator Name",
    "Formula",
    "Actions",
  ];
  
  export const KPItabledata = [
    {
      kpistatus: " ",
      id: "01",
      IndicatorName: "Ignored Transaction",
      Formula: "",
      action: "",
    },
    {
      workstatus: " ",
      id: "02",
      IndicatorName: "Expenses",
      Formula: "",
      action: "",
    },
    {
      workstatus: " ",
      id: "03",
      IndicatorName: "Expected Transaction",
      Formula: "",
      action: "",
    },
    {
      workstatus: " ",
      id: "04",
      IndicatorName: "Expected Transaction",
      Formula: "",
      action: "",
    },
    {
      workstatus: " ",
      id: "05",
      IndicatorName: "Expected Transaction",
      Formula: "",
      action: "",
    },
    {
      workstatus: " ",
      id: "06",
      IndicatorName: "Ignored Transaction",
      Formula: "",
      action: "",
    },
  ];
  